__turbopack_context__.v({
  "fadeEnter": "TimeSlider-module__1PZFdq__fadeEnter",
  "fadeEnterActive": "TimeSlider-module__1PZFdq__fadeEnterActive",
  "fadeExit": "TimeSlider-module__1PZFdq__fadeExit",
  "fadeExitActive": "TimeSlider-module__1PZFdq__fadeExitActive",
});
